<template>
  <v-container fluid>
    <v-layout child-flex>
      <DataCrud
      :canAdd="true"
      :subModules="subModules"
      :storeType="storeType"
      :showSub="true"
      :toolbarTitle="toolbarTitle"
      :formTitle="formTitle"
      :formModel="getFormModel()"
      :headers="getHeaders()"
      :newItemTitle="$vuetify.lang.t('$vuetify.enums.new')">
      </DataCrud>
    </v-layout>
  </v-container>
</template>

<script>
import DataCrud from '../components/DataCrud.vue';
import model from '../models/enums';
import enumItems from '../models/enumItems';


export default {
  name: 'Enums',
  data: () => ({
    search: '',
    // roles: ['admin','user','client'],
    expanded: [],
    storeType: 'enums',
    subModules: [
      {
        name: 'Položky číselníka', class: 'enumItems', icon: 'build', model: enumItems, canAdd: true, parent: 'enums',
      },
    ],
  }),

  components: {
    DataCrud,
  },
  methods: {
    getFormModel() {
      return model.formModel;
    },
    getHeaders() {
      return model.headers;
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Nový kontakt' : 'Úprava kontaktu';
    },
    toolbarTitle() {
      return this.$vuetify.lang.t(`$vuetify.${this.storeType}.title`);
    },
  },
};
</script>
